import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { CopyButtonComponent } from './CopyButton.component';
import { CopyLinkButtonComponent } from './CopyLinkButton.component';
import { CopyToClipboardComponent } from './CopyToClipboard.component';
import { CopyToClipboardButtonComponent } from './CopyToClipboardButton.component';

@NgModule({
    imports: [CommonModule, CoreUiModule],
    declarations: [
        CopyToClipboardComponent,
        CopyToClipboardButtonComponent,
        CopyButtonComponent,
        CopyLinkButtonComponent
    ],
    exports: [
        CopyToClipboardComponent,
        CopyToClipboardButtonComponent,
        CopyButtonComponent,
        CopyLinkButtonComponent
    ],
    providers: []
})
export class CopyToClipboardModule {}
